import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const shopeeDocsGuard: CanActivateFn = (route, state): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Use the isShopeeDocsTeam$ observable from AuthService
  return authService.isShopeeDocsTeam$.pipe(
    take(1), // Take the current value and complete
    map(isShopeeDocsTeam => {
      if (isShopeeDocsTeam) {
        return true; // Allow access if user is in ShopeeDocsTeam
      } else {
        // If user is logged in but not in ShopeeDocsTeam, redirect them
        console.warn('ShopeeDocsGuard: User is not in ShopeeDocsTeam. Redirecting to dashboard.');
        router.navigate(['/dashboard']); // Redirect to the main dashboard page
        return false; // Prevent access to the ShopeeDocsTeam route
      }
    })
  );
};